<mat-dialog-content>
  <div class="img-block">
    <img class="entity-img" alt="{{mediaInfo.title}}" src="{{imgPath}}{{mediaInfo.thumb}}"/>
  </div>
  <div class="caption">{{mediaInfo.caption}}</div>
  <div class="credit">{{mediaInfo.credit}}</div>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="close" tabindex="0">
    <img alt="close modal" src="assets/img/exit-btn.svg">
  </button>
</div>